/**
 * Created by Arison on 2019/7/25.
 */
import React from 'react';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import {Button} from "antd";
import "./PayResult.css"
import { connect } from 'react-redux'

class PayResult extends React.Component{
    constructor(props){
        super(props);
        this.state={
            name:'PayResult',
            height: document.documentElement.clientHeight,
        };
    }


    componentDidMount(){

    }

    render(){
        let stuId = "10097";
        if (this.props.userInfo.userRole === 1) {//家长
            if (this.props.userInfo.parent != null) {
                if (this.props.userInfo.parent.student != null) {
                    if (this.props.userInfo.parent.student.stuId != null) {
                        stuId = this.props.userInfo.parent.student.stuId;
                    }
                }
            }
        }else{
            if(this.props.userInfo.user!=null){
                if(this.props.userInfo.user.userFunId!=null){
                    stuId=this.props.userInfo.user.userFunId;
                }
            }
        }

        return <div  className="flex_column  bg_lightgrey "
        style={{height:this.state.height}}>
            <div className="flex_column bg_white">
                <div className="flex_row">
                    <div className="item_flex_5 flex_column flex_center">
                        <div className="page_v_line"></div>
                        <div className="">
                            <img className="img-circle"
                                 src={require("imgs/icon_pay_success.png")}
                                 width={32}
                                 height={32} />
                        </div>
                        <div className="page_v_line"></div>
                    </div>
                    <div className=" flex_column padding_15">
                        <div className="text_bold span_16">支付成功</div>
                        <div className="div-long-text color_lightGray">充值卡号(一卡通，充值学工号{stuId}：微信充值{this.props.match.params.money}元)</div>
                    </div>
                </div>
                <div className="flex_row">
                   <div className="item_flex_5 flex_column flex_center">
                       <div className="page_v_line"></div>
                       <div className="">
                           <img className="img-circle"
                                                src={require("imgs/icon_pay_money.png")}
                                                width={32}
                                                height={32} />
                       </div>
                       <div className="page_v_line"></div>
                   </div>
                   <div className="flex_column padding_15  margin_top_bottom_10">
                       <div className="text_bold span_16">领款</div>
                       <div className="div-long-text color_lightGray ">
                           请持校园卡消费时完成领款</div>
                   </div>
               </div>
            </div>
            <div  className="margin_15">
                <div className="margin_bottom_10 color_lightGray ">温馨提醒</div>
                <div className="color_lightGray">支付成功之后，请持校园卡到消费机设备消费时完成领款，未领款实际到账时间以校园卡管理机构处理为主</div>
            </div>

            <div className="flex_row margin_top_20">
                <Button className="item_flex btn-ant-btn margin_left_right_15"
                        onClick={() => {
                            this.props.history.goBack();
                        }}>完成</Button>
            </div>
        </div>
    }
}

const mapStateToProps = state => ({
    userOpenid: state.redUserInfo.userOpenid,
    userInfo: {...state.redUserInfo}
})

const mapDispatchToProps = dispatch => ({
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PayResult);